import {
  CampaignCard,
  MajorLinkBigCard,
  MajorLinkSmallCard,
  SCMajorLinkCard,
} from './megaMenuTypes';

export function isSmallCard(el: SCMajorLinkCard): el is MajorLinkSmallCard {
  return 'Header' in el;
}

export function isBigCard(el: SCMajorLinkCard): el is MajorLinkBigCard {
  return 'Description' in el;
}

export function isCampaignCard(el: SCMajorLinkCard): el is CampaignCard {
  return 'Footer' in el;
}

export function getBgBasedColor(bgColor: string): string {
  switch (bgColor) {
    case 'bg-green':
    case 'big-photo':
      return 'text-white';
    case 'bg-lilac-300':
      return 'text-blue-800';
    default:
      return 'text-black';
  }
}

export const CARDS_BG_COLORS = ['bg-lilac-300', 'bg-infographicBgGrey1', 'bg-green'];

const CardColorCache: Record<string, string> = {};

export const getRandomBGColor = (id?: string): string => {
  if (id && CardColorCache[id]) return CardColorCache[id];

  const selectedColor = CARDS_BG_COLORS[Math.floor(Math.random() * CARDS_BG_COLORS.length)];
  if (id) {
    CardColorCache[id] = selectedColor;
  }
  return selectedColor;
};

type GroupedNonCampaignCards = (MajorLinkBigCard | MajorLinkSmallCard[])[];

export function groupNonCampaignCards(cards: SCMajorLinkCard[]): GroupedNonCampaignCards {
  let smallCardsGroup: MajorLinkSmallCard[] = [];
  let groupedCards: GroupedNonCampaignCards = [];

  cards.forEach((card, index) => {
    if (isBigCard(card)) {
      if (smallCardsGroup.length > 0) {
        groupedCards.push([...smallCardsGroup]);
        smallCardsGroup = [];
      }

      groupedCards.push(card);
    } else {
      if (smallCardsGroup.length === 3 || !cards[index + 1]) {
        groupedCards.push([...smallCardsGroup, card]);
        smallCardsGroup = [];
      } else {
        smallCardsGroup.push(card);
      }
    }
  });

  if (Array.isArray(groupedCards[0]) && groupedCards[0].length) {
    const mergedCards: MajorLinkSmallCard[] = [];
    const resultCards: GroupedNonCampaignCards = [];

    groupedCards.sort((a, b) => Number(Array.isArray(a)) - Number(Array.isArray(b)));

    groupedCards.forEach((element) => {
      if (Array.isArray(element)) {
        mergedCards.push(...element);
      } else {
        resultCards.push(element);
      }
    });

    resultCards.push(mergedCards);

    groupedCards = resultCards;
  }

  return groupedCards;
}

export function getCardsContainerGridColumnsClass(items: number): string {
  switch (items) {
    case 1:
      return 'grid-cols-1';
    case 2:
      return 'grid-cols-2';
    case 3:
      return 'grid-cols-3';
    case 4:
      return 'grid-cols-4';
    default:
      return 'grid-cols-1';
  }
}

export function getSmallCardsContainerGridColumnsClass(items: number): string {
  switch (items) {
    case 1:
    case 2:
      return 'grid-cols-1';
    case 3:
    case 4:
      return 'grid-cols-2';
    default:
      return 'grid-cols-3';
  }
}
